<template>
	<div class="con-list">
		<el-form :rules="rules" ref="baseInfoForm" :model="baseInfoForm">
			<ul>
				<li>
					<!-- 国籍和证件类型联动 中国-身份证， 国外-护照  港澳台-通行证-->
					<div class="inline-filed">
						<el-form-item prop="country" label="国籍：" :rules="[{
							required: true, message: '国籍不能为空'}]">
							<el-select
								v-if="!isDetail"
								v-model="baseInfoForm.country"
								:disabled="isDetail || isCheckId"
								filterable
								@change="changeNationType(baseInfoForm.country)" placeholder="请选择">
								<el-option
									v-for="item in nationIdList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-input disabled v-model="applyData.countryDescr" v-else></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item label="语种：" prop="language" :rules="[{required: true, message: ' '}]" v-if="!isDetail">
							<span>{{ baseInfoForm.languageDescr }}</span>
						</el-form-item>
						<el-form-item label="语种：" v-else>
							<span>{{ applyData.languageDescr }}</span>
						</el-form-item>
					</div>
				</li>
				<template v-if="isFN">
					<li>
						<div class="inline-filed">
							<el-form-item prop="firstNameSrch" label="First Name（名）：" :rules="[{required: true, message: 'First Name（名）不能为空'}]" v-if="!isDetail">
								<el-input v-model="baseInfoForm.firstNameSrch" :disabled="isDetail || isCheckId" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item  label="First Name（名）：" v-else>
								<el-input v-model="applyData.firstNameSrch" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
						<div class="inline-filed">
							<el-form-item prop="middleNameSrch" label="Middle Name（中间名）：" v-if="!isDetail">
								<el-input v-model="baseInfoForm.middleNameSrch" :disabled="isDetail || isCheckId" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item  label="Middle Name（中间名）：" v-else>
								<el-input v-model="applyData.middleNameSrch" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
					</li>
					<li>
						<div class="inline-filed">
							<el-form-item
								prop="lastNameSrch"
								label="Last Name（姓）："
								:rules="[{ required: true, message: 'Last Name（姓）不能为空'}]" v-if="!isDetail">
								<el-input v-model="baseInfoForm.lastNameSrch" :disabled="isDetail || isCheckId" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item  label="Last Name（姓）：" v-else>
								<el-input v-model="applyData.lastNameSrch" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
					</li>
				</template>
				<template v-if="!isFN">
					<li>
						<div class="inline-filed">
							<el-form-item
								prop="lastNameSrch"
								label="姓："
								:rules="[{ required: true, message: '姓不能为空'}]" v-if="!isDetail">
								<el-input v-model="baseInfoForm.lastNameSrch" :disabled="isDetail || isCheckId" @change="searchFirstNameSrch('1')" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item  label="姓：" v-else>
								<el-input v-model="applyData.lastNameSrch" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
						<div class="inline-filed">
							<el-form-item prop="firstNameSrch" label="名：" :rules="[{required: true, message: '名不能为空'}]" v-if="!isDetail">
								<el-input v-model="baseInfoForm.firstNameSrch" :disabled="isDetail || isCheckId"  @change="searchFirstNameSrch" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item  label="名：" v-else>
								<el-input v-model="applyData.firstNameSrch" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
					</li>
					<li>
						<div class="inline-filed">
							<el-form-item prop="lastNameAc" label="姓拼音：" :rules="[{required: true, message: '姓拼音不能为空'}]" v-if="!isDetail">
								<el-select v-model="baseInfoForm.lastNameAc" :disabled="isDetail || isCheckId"  placeholder="请选择姓拼音">
								<el-option
									v-for="item in firstNameSrchList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							</el-form-item>
							<el-form-item  label="姓拼音：" v-else>
								<el-input v-model="applyData.lastNameAc" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
						<div class="inline-filed">
							<el-form-item prop="firstNameAc" label="名拼音：" :rules="[{
								required: true, message: '名拼音不能为空'}]" v-if="!isDetail">
								<el-select v-model="baseInfoForm.firstNameAc" :disabled="isDetail || isCheckId" placeholder="请选择名拼音">
									<el-option
										v-for="item in firstNameAcList"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item  label="名拼音：" v-else>
								<el-input v-model="applyData.firstNameAc" :disabled="isDetail"></el-input>
							</el-form-item>
						</div>
					</li>
					<li>
						<div class="inline-filed name-vali">
							<el-form-item prop="fullName" label="姓名拼音：" :rules="[{
								required: true, message: ' '}]" v-if="!isDetail">
								<span>{{ baseInfoForm.fullName }}</span>
							</el-form-item>
							<el-form-item label="姓名拼音："  v-else>
								<span>{{ applyData.fullName }}</span>
							</el-form-item>
						</div>
					</li>
				</template>
				<li>
					<div class="inline-filed">
						<el-form-item prop="nationalIdType" label="证件类型：" :rules="[{
							required: true, message: '证件类型不能为空'}]">
							<el-select v-model="baseInfoForm.nationalIdType"
							:disabled="isDetail || isCheckId"
							v-if="!isDetail"
							@change="changeType(baseInfoForm.nationalIdType)" placeholder="请选择">
								<el-option
									v-for="item in nationalTypeList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-input disabled v-model="applyData.nationalIdTypeDescr" v-else></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="nationalId" label="证件号码：" :rules="[{required: true, message: '证件号码不能为空'}]" v-if="!isDetail">
							<el-input @blur="nationalIdBlur"  @input="nationalIdChange" maxlength="20" v-model.trim="baseInfoForm.nationalId" :disabled="isDetail || isCheckId"  placeholder="请输入证件号码"></el-input>
						</el-form-item>
						<el-form-item prop="nationalId" label="证件号码：" v-else>
							<el-input  v-model="applyData.nationalId" :disabled="isDetail"></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item 
						    prop="birthDate" 
							v-if="!isDetail" 
							label="出生日期：" >
							<el-date-picker
							v-model="baseInfoForm.birthDate"
							:disabled="isDetail || (baseInfoForm.nationalIdType === '1A' && baseInfoForm.nationalId.length === 18 )"
							type="date"
							ref="dataCalc"
							value-format="yyyy-MM-dd"
							placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item v-else label="出生日期：">
							<el-input v-model="applyData.birthDate" disabled></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed nation-vali nation-vali-apply" v-if="!isDetail">
						<el-button size="small" type="default" @click="checkIdCard()" v-if="!isDetail" :disabled="$route.query.type === 'edit'" v-loading.fullscreen.lock="fullscreenLoading">身份验证</el-button>
						<span class="nation-tip" v-if="!isDetail">提示：请验证身份证号与姓名是否匹配，如不匹配，需要重新验证，否则无法提交审批。</span>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item prop="sex" label="性别：" :rules="[{
							required: true, message: '请选择性别'}]" v-if="!isDetail">
							<el-select v-model="baseInfoForm.sex"  :disabled="isDetail || (baseInfoForm.nationalIdType === '1A' && baseInfoForm.nationalId.length === 18 )" placeholder="请选择">
								<el-option key="F" label="女" value="F"></el-option>
								<el-option key="M" label="男" value="M"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="性别：" v-else>
							<el-input disabled v-model="applyData.sexDescr"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="maritalStatus" v-if="!isDetail" label="婚姻状态：" :rules="[{
							required: true, message: '婚姻状态不能为空'}]">
							<el-select v-model="baseInfoForm.maritalStatus"
							:disabled="isDetail"
							placeholder="请选择">
								<el-option
									v-for="item in maritalStatusList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="婚姻状态：" v-else>
							<el-input disabled v-model="applyData.maritalStatusDescr" ></el-input>
						</el-form-item>
					</div>
				</li>
				<div v-for="(child,index) in (!isDetail ? baseInfoForm.nameList : applyData.nameList)" :key="index">
					<li>
						<div class="inline-filed">
							<el-form-item prop="isLanguage" label="是否有多语言姓名：" :rules="[{required: isFN, message: '是否有多语言姓名', trigger: 'change'}]">
								<div v-if="!isDetail" class="field-radio">
									<el-radio-group v-if="!isFN" v-model="baseInfoForm.isLanguage" @change="changeBaseInfo(index)"> 
										<el-radio label="1">是</el-radio>
										<el-radio label="2">否</el-radio>
									</el-radio-group>
									<span v-if="isFN">是</span>
								</div>
								<div v-else class="field-radio">
									<span>{{ child.firstNameSrch ? '是' : '否' }}</span>
								</div>
							</el-form-item>
						</div>
						<div class="inline-filed" v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<el-form-item :prop="`nameList.${index}.language`" label="语种：" v-if="!isDetail">
								<el-select v-model="child.language" :disabled="isDetail" placeholder="请选择" @change="languageChange(child.language, index)">
									<el-option
										v-for="item in languageList"
										:key="item.code"
										:label="item.descr"
										:value="item.code"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="语种：" v-else>
								<span>{{ child.languageDescr }}</span>
							</el-form-item>
						</div>
					</li>
					<template v-if="!isFN">
						<li v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<div class="inline-filed">
								<el-form-item :prop="`nameList.${index}.firstNameSrch`" label="First Name（名）：" v-if="!isDetail">
									<el-input v-model="child.firstNameSrch" :disabled="isDetail" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item  label="First Name（名）：" v-else>
									<el-input v-model="child.firstNameSrch" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
							<div class="inline-filed">
								<el-form-item :prop="`nameList.${index}.middleNameSrch`" label="Middle Name（中间名）：" v-if="!isDetail">
									<el-input v-model="child.middleNameSrch" :disabled="isDetail" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item label="Middle Name（中间名）：" v-else>
									<el-input v-model="child.middleNameSrch" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
						</li>
						<li v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<div class="inline-filed">
								<el-form-item
									:prop="`nameList.${index}.lastNameSrch`"
									label="Last Name（姓）："
									v-if="!isDetail">
									<el-input v-model="child.lastNameSrch" :disabled="isDetail" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item  label="Last Name（姓）：" v-else>
									<el-input v-model="child.lastNameSrch" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
						</li>
					</template>
					<template v-if="isFN">
						<li v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<div class="inline-filed">
								<el-form-item
									:prop="`nameList.${index}.lastNameSrch`"
									label="姓："
									v-if="!isDetail">
									<el-input v-model="child.lastNameSrch" :disabled="isDetail" @change="searchFirstNameSrch('1', 'other')" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item  label="姓：" v-else>
									<el-input v-model="child.lastNameSrch" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
							<div class="inline-filed">
								<el-form-item :prop="`nameList.${index}.firstNameSrch`" label="名：" v-if="!isDetail">
									<el-input v-model="child.firstNameSrch" :disabled="isDetail" @change="searchFirstNameSrch(null, 'other')" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item  label="名：" v-else>
									<el-input v-model="child.firstNameSrch" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
						</li>
						<li v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<div class="inline-filed">
								<el-form-item :prop="`nameList.${index}.lastNameAc`" label="姓拼音：" v-if="!isDetail">
									<el-select v-model="child.lastNameAc" :disabled="isDetail"  placeholder="请选择姓拼音">
										<el-option
											v-for="item in firstNameSrchOtherList"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item  label="姓拼音：" v-else>
									<el-input v-model="child.lastNameAc" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
							<div class="inline-filed">
								<el-form-item :prop="`nameList.${index}.firstNameAc`" label="名拼音：" v-if="!isDetail">
									<el-select v-model="child.firstNameAc" :disabled="isDetail" placeholder="请选择名拼音">
										<el-option
											v-for="item in firstNameAcOtherList"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item  label="名拼音：" v-else>
									<el-input v-model="child.firstNameAc" :disabled="isDetail"></el-input>
								</el-form-item>
							</div>
						</li>
						<li v-if="baseInfoForm.isLanguage === '1' || applyData.isLanguage === '1'">
							<div class="inline-filed name-vali">
								<el-form-item :prop="`nameList.${index}.fullName`" label="姓名拼音：" v-if="!isDetail">
									<span>{{ child.fullName }}</span>
								</el-form-item>
								<el-form-item label="姓名拼音："  v-else>
									<span>{{ child.fullName }}</span>
								</el-form-item>
							</div>
						</li>
					</template>
				</div>
				<li>
					<div class="inline-filed">
						<el-form-item prop="phone" label="手机号：">
							<el-input v-model="baseInfoForm.phone" v-if="!isDetail" placeholder="请输入手机号"></el-input>
							<el-input v-model="applyData.entryPhone" v-else :disabled="isDetail"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="email" label="个人邮箱：" v-if="!isDetail">
							<el-input v-model="baseInfoForm.email" placeholder="请输入个人邮箱"></el-input>
						</el-form-item>
						<el-form-item label="个人邮箱：" v-else>
							<el-input disabled v-model="applyData.entryEmail"></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<!-- 招聘渠道是内部推荐，才有推荐人-->
					<div class="inline-filed">
						<el-form-item prop="channel" label="招聘渠道：" :rules="[{
							required: true, message: '招聘渠道不能为空'}]" v-if="!isDetail">
							<el-select v-model="baseInfoForm.channel" :disabled="isDetail" v-if="!isDetail" placeholder="请选择">
								<el-option
									v-for="item in channelList"
									:key="item.value"
									:label="item.name"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="招聘渠道：" v-else>
							<el-input disabled v-model="applyData.channelDescr"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed" v-if="baseInfoForm.channel === '3' || applyData.channel === '3'">
						<el-form-item prop="recomUser"  label="推荐人：" :rules="[{
							required: true, message: '推荐人不能为空'}]">
							<el-select
								v-if="!isDetail && baseInfoForm.channel === '3'"
								:disabled="isDetail"
								v-model="baseInfoForm.recomUser"
								:remote-method="getPersonInfo"
								filterable
								clearable
								remote
								placeholder="请输入推荐人名字搜索"
								@focus="personList=[]"
								@clear="personList=[]">
								<el-option
									v-for="item in personList"
									:key="item.empId"
									:label="item.name"
									:value="item.empId">
									<span>{{ item.name }}/{{ item.deptName}}</span>
								</el-option>
							</el-select>
							<el-input disabled v-model="applyData.recomUserName" v-else-if="isDetail && applyData.channel === '3'" ></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item
							prop="interviewType"
							label="面试类型："
							:rules="[{ required: true, message: '请填写面试类型'}]" v-if="!isDetail">
							<el-select v-model="baseInfoForm.interviewType" :disabled="isDetail" v-if="!isDetail" placeholder="请填写面试类型">
								<el-option
									v-for="item in interviewTypeList"
									:key="item.value"
									:label="item.name"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item  label="面试类型：" prop="" v-else>
							<el-input v-model="getInterviewType" :disabled="isDetail"></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed width100">
						<el-form-item
							prop="curResidentAddress"
							label="现住址："
							v-if="!isDetail">
							<el-input v-model="baseInfoForm.curResidentAddress" :disabled="isDetail"  placeholder="请精确到门牌号，填写需要10个字以上" maxlength="400"></el-input>
						</el-form-item>
						<el-form-item  label="现住址：" v-else>
							<el-input v-model="applyData.curResidentAddress" :disabled="isDetail"></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item prop="driverLicenseType" v-if="!isDetail" label="驾驶执照类型：" :rules="[{
							required: true, message: '驾驶执照类型不能为空'}]">
							<el-select v-model="baseInfoForm.driverLicenseType"
							:disabled="isDetail"
							@change="chageDriverLicenseType(baseInfoForm.driverLicenseType)"
							placeholder="请选择">
								<el-option
									v-for="item in driverLicenseTypeList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-else label="驾驶执照类型：">
							<el-input disabled v-model="applyData.driverLicenseTypeDescr"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed" v-if="baseInfoForm.driverLicenseType!='10' && applyData.driverLicenseTypeDescr!=='无'">
						<el-form-item prop="driverLicenseEffectDate" v-if="!isDetail" label="驾驶执照到期日：" :rules="[{
						required: true, message: '驾驶执照到期日不能为空'}]">
							<el-date-picker
							v-model="baseInfoForm.driverLicenseEffectDate"
							:disabled="isDetail"
							type="date"
							ref="dataCalc"
							value-format="yyyy-MM-dd"
							placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item v-if="isDetail && applyData.driverLicenseTypeDescr !== '无'" label="驾驶执照到期日：">
							<el-input v-model="applyData.driverLicenseEffectDate" disabled></el-input>
						</el-form-item>
					</div>
				</li>

				<li>
					<div class="inline-filed">
						<el-form-item
							prop="emergencyContactor"
							label="紧急联系人姓名："
							:rules="[{ required: true, message: '紧急联系人姓名不能为空'}]" v-if="!isDetail">
							<el-input v-model="baseInfoForm.emergencyContactor" :disabled="isDetail"  placeholder="请输入紧急联系人姓名" maxlength="100"></el-input>
						</el-form-item>
						<el-form-item  label="紧急联系人姓名：" v-else>
							<el-input v-model="applyData.emergencyContactor" :disabled="isDetail"></el-input>
						</el-form-item>
					</div>

					<div class="inline-filed">
						<el-form-item v-if="!isDetail" prop="relationWithSelf" label="与本人关系：" :rules="[{
							required: true, message: '与本人关系不能为空'}]">
							<el-select
								v-model="baseInfoForm.relationWithSelf"
								:disabled="isDetail"
								placeholder="请选择">
								<el-option
									v-for="item in relationWithSelfList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="与本人关系：" v-else>
							<el-input disabled v-model="applyData.relationWithSelfDescr"></el-input>
						</el-form-item>
					</div>
				</li>

				<li>
					<div class="inline-filed">
						<el-form-item
							prop="emergencyContactorPhone"
							label="紧急联系人电话：" v-if="!isDetail">
							<el-input v-model="baseInfoForm.emergencyContactorPhone" :disabled="isDetail"  placeholder="请输入紧急联系人电话" maxlength="20"></el-input>
						</el-form-item>
						<el-form-item  label="紧急联系人电话：" v-else>
							<el-input v-model="applyData.emergencyContactorPhone" :disabled="isDetail"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="politicalStatus" v-if="!isDetail" label="政治面貌：" :rules="[{
							required: true, message: '政治面貌不能为空'}]">
							<el-select v-model="baseInfoForm.politicalStatus"
							:disabled="isDetail"
							placeholder="请选择">
								<el-option
									v-for="item in politicalStatusList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="政治面貌：" v-else>
							<el-input disabled v-model="applyData.politicalStatusDescr" ></el-input>
						</el-form-item>
					</div>
				</li>
			</ul>
		</el-form>
		<el-dialog
            title="提示"
            :visible.sync="checkDialogVisible"
            width="30%">
            <span>{{checkJobTerLit}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="checkDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
		<el-dialog
            title="提示"
            :visible.sync="checkIdVisible"
            width="30%">
            <span>{{checkIdMsg}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="checkIdVisible = false">确 定</el-button>
            </span>
        </el-dialog>
	</div>
</template>

<script>
import { getPinyin, getOutsideCheckId, getUsers, getDictionary, getCheckJobTerLit, getLanguage } from '../network'
import { staticList } from '../network/staticList'

export default {
	name: 'baseInfo',
	props: {
		applyData: {},
		allCheck: {
			type: Boolean,
		},
		isDetail:{
			type: Boolean,
		},
		value: {}
	},
	model: {
		event: 'baseInfoChange',
	},
	data() {
		const validatephone = (rule, value, callback) => {
			const reg = /^1\d{10}$/
			if (value === '') {
				callback(new Error('手机号码不能为空'))
			} else if (!reg.test(value)) {
				callback(new Error('请正确输入手机号码'))
			} else {
				callback()
			}
		};
		const validateEmail = (rule, value, callback) => {
			const reg = new RegExp('^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$');
			if (value === '') {
				callback(new Error('个人邮箱不能为空'));
			} else if (!reg.test(value)) {
				callback(new Error('请输入正确的个人邮箱'));
			} else {
				callback();
			}
		};
		const validateECPhone = (rule, value, callback) => {
			const reg = /^1\d{10}$/
			if (value === '') {
				callback(new Error('紧急联系人手机号码不能为空'))
			} else if (!reg.test(value)) {
				callback(new Error('请输入正确输入紧急联系人手机号码'))
			} else {
				callback()
			}
		};
		const validateCurResidentAddress = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('现住址不能为空'))
			} else if (value.length<10) {
				callback(new Error('请精确到门牌号，填写需要10个字以上'))
			} else {
				callback()
			}
		};
		return {
			baseInfoForm: {
				lastNameSrch: '', // 姓
				lastNameAc: '', // 姓拼音
				firstNameSrch: '', // 名
				firstNameAc: '', // 名拼音
				middleNameSrch: '', // 中间名
				fullName: '', //名字拼音
				country: 'CHN', // 国籍
				nationalIdType: '1A', // 证件类型
				nationalId: '', // 证件号（加密）
				sex: '', // 性别: M 女  F男
				phone: '', // 电话号码
				email: '', // 邮箱
				channel: '', // 招聘渠道
				recomUser: '', // 推荐人
				maritalStatus: '',//婚姻状态
				birthDate: '',//出生日期
				curResidentAddress: '',//现居地
				driverLicenseType: '',//驾照类型
				driverLicenseEffectDate: '',//驾照到期日
				emergencyContactor: '',//紧急联系人
				emergencyContactorPhone: '',//紧急联系人电话
				relationWithSelf: '',//与本人关系
				politicalStatus:'', //政治面貌
				interviewType: '', // 面试类型
				language: 'zh-CN',
				languageDescr: '中文',
				isLanguage: '',
				nameList: [{ // 多语种
					lastNameSrch: '', // 姓
					lastNameAc: '', // 姓拼音
					firstNameSrch: '', // 名
					firstNameAc: '', // 名拼音
					middleNameSrch: '', // 中间名
					fullName: '', //名字拼音
					language: '',
					languageDescr: '',
				}]
			},
			firstNameSrchList: [], // 姓拼音选择列表 
			firstNameAcList: [], // 名字拼音列表
			firstNameSrchOtherList: [],
			firstNameAcOtherList: [],
			nationalTypeList: [],
			channelList: [], // 招聘渠道
			nationIdList: [], // 国家
			rules: {
				phone: [
					{ required: true, validator: validatephone, trigger: 'blur' },
				],
				email: [
					{ required: true, validator: validateEmail, trigger: 'blur' },
				],
				interviewType: [
					{ required: true, message: '请填写面试类型', trigger: 'change' },
				],
				birthDate: [
					{ required: true, message: '出生日期不能为空', trigger: 'change'},
				],
				emergencyContactorPhone: [
					{ required: true, validator: validateECPhone, trigger: 'blur' },
				],
				curResidentAddress:[
					{ required: true, validator: validateCurResidentAddress, trigger: 'blur'}
				],
				'nameList.0.lastNameSrch': [{ required: true, message: '姓不能为空', trigger: 'blur' }],
				// 'nameList.0.middleNameSrch': [{ required: true, message: '中间名不能为空', trigger: 'blur' }],
				'nameList.0.firstNameSrch': [{ required: true, message: '名不能为空', trigger: 'blur' }],
				'nameList.0.lastNameAc': [{ required: true, message: '姓拼音不能为空', trigger: 'change' }],
				'nameList.0.firstNameAc': [{ required: true, message: '名拼音不能为空', trigger: 'change' }],
				'nameList.0.fullName': [{ required: true, message: ' ', trigger: 'blur' }],
				'nameList.0.language': [{ required: true, message: ' ', trigger: 'blur' }],
			},
			personList:[], // 人员列表
			isCheckId: false,
			fullscreenLoading:false,
			showDriverEff:'',
			checkDialogVisible: false,
			checkJobTerLit: '',
			checkIdVisible: false,
			checkIdMsg: '',
			interviewTypeList: [],
			languageList: [],
			languageDefauleList: [],
		};

	},
	computed: {
		getInterviewType() {
            let arr = this.interviewTypeList || []
            let obj = arr.find((item) => item.value == this.applyData.interviewType)
            if (obj) {
                return obj.name
            }
            return ''
        },
        isFN() { // 是否是外籍
            return this.isDetail ? this.applyData.language !== 'zh-CN' : this.baseInfoForm.language !== 'zh-CN'
        },
	},
	watch: {
		value: {
			handler() {
				const newObj = {};
				this.baseInfoForm = Object.assign(newObj, this.baseInfoForm, this.value);
			},
			deep: true,
		},
		// 'baseInfoForm.nationalId'(valId){
			// if(valId.length === 18 && this.baseInfoForm.nationalIdType === '1A'){
			// 	// 如果身份证是18位，根据倒数第二位判断男女
			// 	valId.substr(16,1)%2 === 0 ? this.baseInfoForm.sex = 'F' : this.baseInfoForm.sex = 'M'
			// 	// 如果身份证是18位，取出出生年月日
			// 	this.baseInfoForm.birthDate = valId.substr(6,4)+"-"+valId.substr(10,2)+"-"+valId.substr(12,2);
			// }
		// },
		'baseInfoForm.lastNameAc'(){
			this.baseInfoForm.fullName = this.baseInfoForm.lastNameAc + this.baseInfoForm.firstNameAc
		},
		'baseInfoForm.firstNameAc'(){
			this.baseInfoForm.fullName = this.baseInfoForm.lastNameAc + this.baseInfoForm.firstNameAc
		},
		'baseInfoForm.nationalId'(val){
			this.baseInfoForm.nationalId = val.trim()
		},
		'baseInfoForm.language': {
            handler(val, oldVal) {
                if (oldVal && val !== oldVal) {
                    this.baseInfoForm.firstNameSrch = ''
                    this.baseInfoForm.middleNameSrch = ''
                    this.baseInfoForm.lastNameSrch = ''
                    this.baseInfoForm.lastNameAc = ''
                    this.baseInfoForm.firstNameAc = ''
					this.baseInfoForm.fullName = ''
                }
            },
        },
		// 添加对 nameList 数组的深度监听
		'baseInfoForm.nameList': {
			handler(newVal, oldVal) {
				if (newVal && Array.isArray(newVal)) {
					newVal.forEach((item, index) => {
						if (item.lastNameAc !== undefined && item.firstNameAc !== undefined) {
							this.$set(
								this.baseInfoForm.nameList[index], 
								'fullName', 
								(item.lastNameAc || '') + (item.firstNameAc || '')
							);
						}
						// 处理language变化时清空相关字段
						if (oldVal && oldVal[index] && item.language !== oldVal[index].language) {
							this.baseInfoForm.nameList[index].firstNameSrch = '';
							this.baseInfoForm.nameList[index].middleNameSrch = '';
							this.baseInfoForm.nameList[index].lastNameSrch = '';
							this.baseInfoForm.nameList[index].lastNameAc = '';
							this.baseInfoForm.nameList[index].firstNameAc = '';
							this.baseInfoForm.nameList[index].fullName = '';
						}
					});
				}
			},
			deep: true
		},
	},
	created() {
		// 静态数据赋值
		this.nationalTypeList = staticList.nationalTypeList
		// this.channelList = staticList.channelList
		this.nationIdList = staticList.nationIdList
		this.maritalStatusList = staticList.maritalStatusList
		this.driverLicenseTypeList = staticList.driverLicenseTypeList
		this.relationWithSelfList = staticList.relationWithSelfList
		this.politicalStatusList = staticList.politicalStatusList
		if (!this.applyData.nameList || !this.applyData.nameList.length) {
			this.applyData.nameList = [{ // 多语种
				lastNameSrch: '', // 姓
				lastNameAc: '', // 姓拼音
				firstNameSrch: '', // 名
				firstNameAc: '', // 名拼音
				middleNameSrch: '', // 中间名
				fullName: '', //名字拼音
			}]
		}
		this.getChannelList()
		this.getLanguageListByValue()
		if (this.$route.query && this.$route.query.type === 'edit') {
			this.isCheckId = true
			this.$emit('isCheckId', true)
		}
	},
	methods: {
		showDriverEffDiv(val){
			this.showDriverEff = ((val === '无')
			 ? false: true)
		},
		nationalIdChange(valId) {
			valId = valId.trim()
			if(valId.length === 18 && this.baseInfoForm.nationalIdType === '1A'){
				// 如果身份证是18位，根据倒数第二位判断男女
				valId.substr(16,1)%2 === 0 ? this.baseInfoForm.sex = 'F' : this.baseInfoForm.sex = 'M'
				// 如果身份证是18位，取出出生年月日
				// this.baseInfoForm.birthDate = valId.substr(6,4)+"-"+valId.substr(10,2)+"-"+valId.substr(12,2)
				this.$set(this.baseInfoForm, 'birthDate',  valId.substr(6,4)+"-"+valId.substr(10,2)+"-"+valId.substr(12,2))
			}
		},
		nationalIdBlur() {
			let { nationalIdType, nationalId } = this.baseInfoForm
            if (nationalIdType && nationalId) {
                this.getCheckJobTer(nationalId, nationalIdType)
            }
		},
		// 根据证件类型和证件号提示校验
        getCheckJobTer(nationalId, nationalType) {
            getCheckJobTerLit({
				nationalId,
                nationalType,
			}).then((res) => {
                let { data: { data, code } } = res
                if (code === 'S00000' && data) {
                    this.checkDialogVisible = true
                    this.checkJobTerLit = data
                }
            }).catch((err) => {
                this.checkDialogVisible = false
            })
        },
		// 选择推荐人
		getPersonInfo(query){
			if (query !== '') {
				setTimeout(() => {
					this.personList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					return getUsers(params).then((res)=>{
						let data =res.data
						if(data.code === 'S00000'){
							this.personList = data.data;
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.personList = []	
			}
		},
		// 根据姓名输入，导入拼音
		searchFirstNameSrch(type, isOtherName){
			// 重置
			if(type === '1'){
				if (isOtherName === 'other') {
					this.baseInfoForm.nameList[0].lastNameAc = ''
				} else {
					this.baseInfoForm.lastNameAc = ''
				}
			}else{
				if (isOtherName === 'other') {
					this.baseInfoForm.nameList[0].firstNameAc = ''
				} else {
					this.baseInfoForm.firstNameAc = ''
				}
			}
			let params = { 
				name: type === '1' ? (isOtherName === 'other' ? this.baseInfoForm.nameList[0].lastNameSrch : this.baseInfoForm.lastNameSrch) : (isOtherName === 'other' ? this.baseInfoForm.nameList[0].firstNameSrch : this.baseInfoForm.firstNameSrch)
			}
			return getPinyin(params).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){	
					let dataList = []
					if(data.data.length){
						for(let i = 0;i<data.data.length; i++ ){
							let listObj = {
								value: data.data[i],
								label: data.data[i],
							}
							dataList.push(listObj)
						}
						if (isOtherName === 'other') {
							type === '1' ? this.firstNameSrchOtherList = dataList : this.firstNameAcOtherList = dataList
							// 如果只有一条数据，不是多音字，直接赋值
							if(this.firstNameSrchOtherList.length === 1){
								this.baseInfoForm.nameList[0].lastNameAc = this.firstNameSrchOtherList[0].value
							}
							if(this.firstNameAcOtherList.length === 1){
								this.baseInfoForm.nameList[0].firstNameAc = this.firstNameAcOtherList[0].value
							}
						} else {
							type === '1' ? this.firstNameSrchList = dataList : this.firstNameAcList = dataList
							// 如果只有一条数据，不是多音字，直接赋值
							if(this.firstNameSrchList.length === 1){
								this.baseInfoForm.lastNameAc = this.firstNameSrchList[0].value
							}
							if(this.firstNameAcList.length === 1){
								this.baseInfoForm.firstNameAc = this.firstNameAcList[0].value
							}
						}
					}
					
				}
			}).catch((error)=>{
				// this.$message.error(JSON.stringify(error))
			})
		},
		// 根据国籍的，选择对应的证件类型
		changeNationType(val) {
			// 如果国籍中国
			if (val === 'CHN') {
				this.baseInfoForm.nationalIdType = '1A';
			} else if (val === 'GAT') {
				this.baseInfoForm.nationalIdType = '1P';
			} else {
				this.baseInfoForm.nationalIdType = '1E';
			}
			this.baseInfoForm.nameList.forEach((item) => {
				item.lastNameSrch = '' // 姓
				item.lastNameAc = '' // 姓拼音
				item.firstNameSrch = '' // 名
				item.firstNameAc = '' // 名拼音
				item.middleNameSrch = '' // 中间名
				item.fullName = '' // 名字拼音
				item.language = ''
				item.languageDescr = ''
			})
			this.baseInfoForm.isLanguage = ''
			this.nationalIdBlur()
            // 获取语种
            this.getLanguageByValue(val)
		},
		getLanguageByValue(val) {
            getLanguage({
                country: val,
            }).then((res) => {
                let { data: { data } } = res
                this.baseInfoForm.language = data && data.length ? data[0].code : ''
                this.baseInfoForm.languageDescr = data && data.length ? data[0].descr : ''
				if (this.baseInfoForm.language !== 'zh-CN') {
					this.baseInfoForm.isLanguage = '1'
					this.baseInfoForm.nameList[0].language = 'zh-CN'
				}
				this.languageList = this.languageDefauleList.filter((item)=>item.code !== this.baseInfoForm.language)
            }).catch((err) => {
                this.baseInfoForm.language = ''
                this.baseInfoForm.languageDescr = ''
            })
        },
		getLanguageListByValue(val) {
            getLanguage().then((res) => {
                let { data: { data } } = res
				this.languageDefauleList = JSON.parse(JSON.stringify(data || []))
				this.languageList = this.languageDefauleList.filter((item)=>item.code !== this.baseInfoForm.language)
            }).catch((err) => {
                this.languageList = []
            })
        },
		chageDriverLicenseType(val){
			if(val === '10'){
				this.$set(this.baseInfoForm, 'driverLicenseEffectDate', '');
			}
		},
		// 证件类型校验国籍
		changeType(val) {
			if ((val === '1A' && this.baseInfoForm.country !== 'CHN')
				|| (val === '1P' && this.baseInfoForm.country !== 'GAT')
				|| (val === '1E' && this.baseInfoForm.country === 'CHN')
				|| (val === '1E' && this.baseInfoForm.country === 'GAT')) {
				this.baseInfoForm.country = '';
			}
			this.nationalIdBlur()
		},
		// 检查必填信息
		validateBase() {
			this.saveBase()
			this.$nextTick(() => {
				this.$refs.baseInfoForm.validate((valid) => {
					if (valid) {
						this.$emit('getBaseCheck', true);
					} else {
						this.$emit('getBaseCheck', false);
					}
				})
			})
		},
		saveBase() {
			const { lastNameSrch, firstNameSrch, lastNameAc, firstNameAc, fullName,
			maritalStatus, nationalId, birthDate, country, nationalIdType,
			channel, sex, phone, email, recomUser, curResidentAddress, driverLicenseType,
			emergencyContactor, driverLicenseEffectDate, politicalStatus, emergencyContactorPhone, relationWithSelf, interviewType, nameList, language, languageDescr, middleNameSrch } = this.baseInfoForm
			this.$emit('changeData', {
				lastNameSrch,
				firstNameSrch,
				lastNameAc,
				firstNameAc,
				fullName,
				maritalStatus,
				country,
				nationalIdType,
				nationalId,
				channel,
				birthDate,
				sex,
				phone,
				email,
				recomUser,
				driverLicenseType,
				curResidentAddress,
				emergencyContactor,
				driverLicenseEffectDate,
				politicalStatus,
				emergencyContactorPhone,
				relationWithSelf,
				interviewType,
				nameList,
				language,
				languageDescr,
				middleNameSrch,
			});
		},
		// 身份证验证
		checkIdCard(){
			if(this.baseInfoForm.lastNameSrch === ''){
				this.$message.warning(this.isFN ? '请输入Last Name（姓）' : '请输入姓')
				return
			}
			if(this.baseInfoForm.firstNameSrch === ''){
				this.$message.warning(this.isFN ? '请输入First Name（名）' : '请输入名')
				return
			}
			if(!this.isFN && this.baseInfoForm.lastNameAc === ''){
				this.$message.warning('请输入姓拼音')
				return
			}
			if(!this.isFN && this.baseInfoForm.firstNameAc === ''){
				this.$message.warning('请输入名拼音')
				return
			}
			if(this.baseInfoForm.nationalId === ''){
				this.$message.warning('请输入证件号码')
				return
			}
			if (!this.applyData.emplType) {
				this.$message.warning('请先选择人员类别')
				return
			}
			let params = {
				name: this.baseInfoForm.lastNameSrch + this.baseInfoForm.firstNameSrch,
				nationalId: this.baseInfoForm.nationalId,
				nationalIdType: this.baseInfoForm.nationalIdType,
				emplType: this.applyData.emplType,
			}
			this.fullscreenLoading = true
			return getOutsideCheckId(params).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					if (data.data) {
						this.$message.success(`身份验证成功，${data.data}`)
					} else {
						this.$message.success('身份验证成功')
					}
					this.isCheckId = true
					this.$emit('isCheckId', true)
					this.fullscreenLoading = false
				} else {
					this.$message.error('身份验证失败，请检查')
					this.$emit('isCheckId', false)
					this.fullscreenLoading = false
				}
			}).catch((error)=>{
				this.fullscreenLoading = false
				this.checkIdVisible = true
				this.checkIdMsg = error.response && error.response.data ? error.response.data.message : ''
				// this.$message.error(JSON.stringify(error))
			})
		},
		// 获取招聘渠道
		getChannelList(){
			getDictionary({
				typeString: 'ENTRY_CHANNEL,INDUCTION_INTERVIEW_TYPE'
			}).then((res)=>{
				let data =res.data
				if(data.code === 'S00000'){
					const sysDictRespDTOList = data.data && data.data[0] && data.data[0].sysDictRespDTOList ? data.data[0].sysDictRespDTOList : []
					const interviewTypeList = data.data && data.data[1] && data.data[1].sysDictRespDTOList ? data.data[1].sysDictRespDTOList : []
					this.channelList = sysDictRespDTOList;
					this.interviewTypeList = interviewTypeList
				} else {
					this.$message.error(data.message)
				}
			}).catch((error)=>{
				// this.$message.error(JSON.stringify(error))
			})
		},
		changeBaseInfo(index) {
			this.baseInfoForm.nameList[index].lastNameSrch = ''
			this.baseInfoForm.nameList[index].lastNameAc = ''
			this.baseInfoForm.nameList[index].firstNameSrch = ''
			this.baseInfoForm.nameList[index].firstNameAc = ''
			this.baseInfoForm.nameList[index].middleNameSrch = ''
			this.baseInfoForm.nameList[index].fullName = ''
			this.baseInfoForm.nameList[index].isLanguage = ''
			this.baseInfoForm.nameList[index].isLanguageDescr = ''
		},
		languageChange(val, index) {
			let currrentList = this.languageList.filter((item) => item.languageCode === val)
			currrentList && currrentList.length && (this.baseInfoForm.nameList[index].isLanguageDescr = currrentList[0].languageDescr)
		}
	},
};
</script>

<style lang="scss">
	.width100{
		width: 100%;
		.el-form-item .el-input{
			width: 500px;
		}
	}
	.name-vali{
		position:relative;
		.tip{
			display:inline-block;
			color: #FF2C2C;
			width: 380px;
			overflow: hidden;
			font-size:12px;
			position: absolute;
			top: 0px;
			left: 400px;
		}
	}
	.nation-vali {
		position: relative;
		.el-form-item {
			position: relative;
		}
		.el-button{
			margin-left: 30px;
		}
		.nation-tip{
			font-size:12px;
			display:block;
			color: #FF2C2C;
			position: absolute;
			left: 178px;
    		top: -3px;
			line-height:18px;
			width: 260px;
		}
	}
	.nation-vali-apply{
		padding-left: 58px;
	}
</style>
